import { render } from "./StockReport.vue?vue&type=template&id=f84ef3e8&scoped=true&ts=true"
import script from "./StockReport.vue?vue&type=script&lang=ts"
export * from "./StockReport.vue?vue&type=script&lang=ts"

import "./StockReport.vue?vue&type=style&index=0&id=f84ef3e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84ef3e8"]])

export default __exports__